import React from 'react';

const HistoryIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24.945"
    height="24.944"
    viewBox="0 0 24.945 24.944"
  >
    <path
      id="History"
      d="M241.34,172.9a11.472,11.472,0,1,1,11.472-11.472A11.485,11.485,0,0,1,241.34,172.9Zm0-21.6a10.126,10.126,0,1,0,10.126,10.126A10.138,10.138,0,0,0,241.34,151.3Zm1.418,2.477a.673.673,0,1,0-1.346,0v7.653h-5.1a.673.673,0,0,0,0,1.346h6.448Z"
      transform="translate(-228.868 -148.954)"
    />
  </svg>
);

export default HistoryIcon;
